<template>
    <div class="details_container">
        <img src="@/assets/themeThree/agentGraph.png" alt="" width="100%">
        <div class="qCard">
            <div class="card_details" v-html="$t('agent.definitionContentTheme3')"></div>
        </div>
    </div>
</template>

<script setup lang="ts">


</script>

<style scoped>
.details_container {
    padding: 15px 0;
    background: #101629;
}

.qCard {
    border-radius: 10px;
    border: 1px solid #2A324E;
    padding: 5px;
    margin: 5px;
    line-height: 20px;
    color: #6D788D;
}

.qCard span {
    color: #FFEE00;
}

.title {
    font-size: 16px;
    font-weight: 700;
}

.card_details {
    color: #6D788D;
    line-height: 15px;
}
</style>